const polyfill     = require('smooth-scroll/dist/smooth-scroll.polyfills');
const SmoothScroll = require('smooth-scroll');

const $ = require('./gs-zepto').default;

const selector = 'a[href*="#"]';
const options = {
	speed: 800,
	speedAsDuration: true,
	offset: () => $('.gs-NavBar, .gs-TabBar, .gs-ContentPreview-tabs').height() + 15
};

polyfill();
module.exports = new SmoothScroll(selector, options);


//
// On initial load, adjust to accommodate nav bar if needed
//

$(function() {
	if (location.hash) {
		setTimeout(() => {
			let win = $(window);
			let pos = win.scrollTop() - options.offset();
			win.scrollTop(pos);
		});
	}
});

